








































































import Vue from 'vue';
import { ELanguage, ESearchPostType, EUserRole } from '@ringana/configs';
import CookieHelper from '@/helpers/OldCookieHelper';
import { IApiSearchResult } from '@/common/interfaces/api.interface';
import LoadingSpinner from '@/components/common/loading/LoadingSpinner.vue';
import { ISearchboxComponent } from '../../common/interfaces/searchbox.interface';
import Articles from './resultcomponents/Articles.vue';
import CustomButton from '../layout/buttons/CustomButton.vue';
import FilterTextInput from '../layout/inputs/FilterTextInput.vue';
import KnowledgeBase from './resultcomponents/KnowledgeBase.vue';
import LocalStorageHelper from '../../helpers/LocalStorageHelper';
import Products from './resultcomponents/Products.vue';
import TIcons from '../../types/TIcons';
import config from '../../../config';

export default Vue.extend({
  name: `Searchbox`,
  components: {
    Articles,
    CustomButton,
    FilterTextInput,
    KnowledgeBase,
    LoadingSpinner,
    Products,
  },
  data(): ISearchboxComponent {
    return {
      debouncedFilter: null,
      icons: TIcons,
      isPartner: false,
      loading: {
        redirectLoading: false,
        resultLoading: false,
      },
      search: {
        result: {
          articles: [],
          knowledgeBase: [],
          products: [],
        },
        searchString: ``,
      },
      selectedLanguage: null,
    };
  },
  computed: {
    searchStringValid(): boolean {
      return this.search.searchString.length > 2;
    },
  },
  props: {
    isMobileView: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    this.fetchCustomerRole();
    this.getSelectedLanguage();
    this.debouncedFilter = window._.debounce(this.filter, 250);
  },
  methods: {
    assembleArticles(data: IApiSearchResult[]): void {
      const articles = data.find(item => {
        return item.postType === ESearchPostType.NEWS_ARTICLE.toString();
      });
      const blogs = data.find(item => {
        return item.postType === ESearchPostType.BLOG.toString();
      });
      this.search.result.articles = [
        ...articles?.data ?? [],
        ...blogs?.data ?? [],
      ];
    },
    assembleKnowledgeBase(data: IApiSearchResult[]): void {
      const knowledgeBase = data.find(item => item.postType === ESearchPostType.KNOWLEDGE_BASE_ENTRY.toString());
      this.search.result.knowledgeBase = knowledgeBase?.data ?? [];
    },
    assembleProducts(data: IApiSearchResult[]): void {
      const products = data.find(item => {
        return item.postType === ESearchPostType.PRODUCT.toString();
      });
      const partnerProducts = data.find(item => {
        return item.postType === ESearchPostType.PARTNER_PRODUCT.toString();
      });
      this.search.result.products = [
        ...products?.data ?? [],
        ...partnerProducts?.data ?? [],
      ];
    },
    closeSearchbox(): void {
      this.resetSearchResult();
      this.search.searchString = ``;
    },
    fetchCustomerRole(): void {
      const personalInfo = LocalStorageHelper.getPersonalInfo();
      if(personalInfo) {
        this.isPartner = personalInfo.isPartner;
      }
    },
    async filter(): Promise<void> {
      if(!this.searchStringValid) {
        return;
      }
      this.resetSearchResult();

      this.loading.resultLoading = true;

      let response;

      try {
        response = await this.$apiService.getSearchData({
          data: {
            lang: this.selectedLanguage as ELanguage,
            limit: config.api.searchbox.resultLimit,
            showHiddenCategories: false,
            term: this.search.searchString,
          },
          params: {
            role: this.isPartner ? EUserRole.PARTNER : EUserRole.CUSTOMER,
          },
        });
      } catch (err) {
        this.loading.resultLoading = false;
        this.resetSearchResult();
        return;
      }

      const { data } = response;

      this.assembleArticles(data);
      this.assembleKnowledgeBase(data);
      this.assembleProducts(data);

      this.loading.resultLoading = false;
    },
    getSelectedLanguage(): void {
      this.selectedLanguage = CookieHelper.getLanguage() as ELanguage;

      if(!this.selectedLanguage) {
        this.selectedLanguage = ELanguage.DE;
      }
    },
    isButtonDisabled(): boolean {
      return this.loading.resultLoading || this.loading.redirectLoading;
    },
    redirectToSearch(): void {
      if(this.searchStringValid) {
        this.loading.redirectLoading = true;
        window.location.href = `/?s=${this.search.searchString}&lang=${this.selectedLanguage}`;
      }
    },
    resetSearchResult(): void {
      this.search.result.articles = [];
      this.search.result.knowledgeBase = [];
      this.search.result.products = [];
    },
  },
});
